export const FORGOT_PASSWORD = "FORGOT_PASSWORD"
export const FORGOT_PASSWORD_SUCCESSFUL = "FORGOT_PASSWORD_SUCCESSFUL"
export const FORGOT_PASSWORD_FAILED = "FORGOT_PASSWORD_FAILED"
export const FORGOT_PASSWORD_RESET = "FORGOT_PASSWORD_RESET"